// removed by extract-text-webpack-plugin
module.exports = {"addevent":"_29TnTh1DE0nUvqXJkBPs9h","addeventCategory":"_1izDm58ikPleijUV8eIV9N","criarWrap":"gpCahJ6yYA5dM_3SVGF6a","criar":"_2QFOGyNoe-FLdUERcCRuuZ","eventitem":"dt7H5ENsE3giHKg07byqD","type":"_1tlVRSWOXFw69T6MLgAbMe","event":"_16vxbZG7Q_0K-p9YjVEAoc","copydata":"_2qM1EPT_wnXR4Xgfzfob-0","title":"_3PINOz5qV7ERbx85k4Enq-","date":"_2n7mCyL1upX9ZKemhf9TfF","eventdayhour":"_1fC32-Q_hht7VJatA-09Xz","tagevent":"_2ASLbiQIeKWYGn6lrTL-Ue","text":"_1vpX0oorYyMI4nItABFIxa","transparent":"_3JhbtRZLBTsU58Fr95ZzVZ"};


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/CreateEvent/Copy/style.css
// module id = 414
// module chunks = 39